module.exports = __webpack_public_path__ + "static/media/Approvals.fc633232.jpg";